import { unsafeLocalizedString } from "@dbn/omnichannel-design-system-g4p";
import { option, record } from "fp-ts";
import { pipe } from "fp-ts/function";
import { Option } from "fp-ts/Option";
import { Banker } from "../../MortgageDashboard/domain";

type List = { [index: string]: string };

export const optionsFromList = (list: List) =>
  pipe(
    list,
    record.collect((value, label) => ({
      value,
      label: unsafeLocalizedString(label),
    }))
  );

export const optionFromListKey = (list: List) => (value: Option<string>) =>
  pipe(
    value,
    option.filter(value => list.hasOwnProperty(value)),
    option.map(value => ({
      value,
      label: unsafeLocalizedString(list[value]),
    }))
  );

export const optionsFromArray = (list: Banker[]) =>
  pipe(
    list.map(element => ({
      value: element.username,
      label: unsafeLocalizedString(element.name),
    }))
  );

export const optionFromArrayKey = (list: Banker[]) => (
  value: Option<string>
) => {
  if (option.isSome(value)) {
    var newArray = list.filter(function (el) {
      return el.username === value.value;
    });

    return newArray.map(element =>
      option.some({
        value: element.username,
        label: unsafeLocalizedString(element.name),
      })
    )[0];
  }
  return option.none;
};
